export default __webpack_public_path__ + "static/gallery17-ca6a2c9ea152670adb2a415fe69273cf.png";